import { render } from "./SlotPage.vue?vue&type=template&id=31a71050&scoped=true"
import script from "./SlotPage.vue?vue&type=script&lang=js"
export * from "./SlotPage.vue?vue&type=script&lang=js"

import "./SlotPage.vue?vue&type=style&index=0&id=31a71050&scoped=true&lang=css"
import "./SlotPage.vue?vue&type=style&index=1&id=31a71050&scoped=true&lang=css"

import exportComponent from "/Users/derem1991/workspace/newear/frontend/theearcasino/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31a71050"]])

export default __exports__